import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { RequireAuth } from "@/components/RequireAuth";
import { BlocksPage } from "@/routes/blocks";
import { BookmarkletPage } from "@/routes/bookmarklet";
import { IpsPage } from "@/routes/ips";
import { LinkDetailPage } from "@/routes/link-detail";
import { LinkImportPage } from "@/routes/link-import";
import { LinkNewPage } from "@/routes/link-new";
import { LinksPage } from "@/routes/links";
import { LoginPage } from "@/routes/login";
import { LogDetailPage } from "@/routes/log-detail";
import { LogIpPage } from "@/routes/log-ip";
import { LogsPage } from "@/routes/logs";
import { ResetPage } from "@/routes/reset";
import { SettingsPage } from "@/routes/settings";
import { SessionProvider } from "@/session/SessionProvider";
import { ThemeProvider } from "@/theme/ThemeProvider";

export function App() {
	return (
		<ThemeProvider>
			<SessionProvider>
				<BrowserRouter>
					<Routes>
						<Route path="/login" element={<LoginPage />} />
						<Route path="/reset" element={<ResetPage />} />
						<Route
							element={
								<RequireAuth>
									<AppShell />
								</RequireAuth>
							}
						>
							{/* `/` is owned by the Worker (301 → HOME_REDIRECT_URL); SPA starts at /links */}
							<Route path="/links" element={<LinksPage />} />
							<Route path="/links/new" element={<LinkNewPage />} />
							<Route path="/links/import" element={<LinkImportPage />} />
							<Route path="/links/:id" element={<LinkDetailPage />} />
							<Route path="/bookmarklet" element={<BookmarkletPage />} />
							<Route path="/blocks" element={<BlocksPage />} />
							<Route path="/logs" element={<LogsPage />} />
							<Route path="/logs/view" element={<LogDetailPage />} />
							<Route path="/logs/ip" element={<LogIpPage />} />
							<Route path="/ips" element={<IpsPage />} />
							<Route path="/settings" element={<SettingsPage />} />
						</Route>
						<Route path="*" element={<Navigate to="/links" replace />} />
					</Routes>
				</BrowserRouter>
			</SessionProvider>
		</ThemeProvider>
	);
}
